import { render, staticRenderFns } from "./tabs-secondary.vue?vue&type=template&id=7c9cb142&scoped=true&"
import script from "./tabs-secondary.vue?vue&type=script&lang=js&"
export * from "./tabs-secondary.vue?vue&type=script&lang=js&"
import style0 from "./tabs-secondary.vue?vue&type=style&index=0&id=7c9cb142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9cb142",
  null
  
)

export default component.exports